import React from 'react';

function AboutUs() {
  return (
    <div className="container py-4">
      <h1 className="display-4 mb-4 text-center">About Us</h1>
      <h2 className="display-6 text-center">Learning should be fun!</h2>
      <p className="text-center">At Tlanimi, the creators of BioEra™, we believe in unlocking the potential of curious minds. We want to create more than entertainment: we design meaningful experiences to learn while having fun. Feel good knowing that time spent in these experiences leaves a positive impact on the mind.</p>
      <h2 className="display-6 mb-4 text-center">Our Promise</h2>
      <p className="text-center">At Tlanimi, we promise to reward curious minds with factual, quality and entertaining content. We are a US-based company that ethically sources our materials.</p>
    </div>
  );
}

export default AboutUs;
